import React from 'react'
import { Pie } from 'react-chartjs-2'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { ChartProps } from 'react-chartjs-2/dist/types'

ChartJS.register(ArcElement, Tooltip, Legend)

interface PieChartProps extends ChartProps<'pie'> {
  height?: number
}

const PieChart: React.FC<PieChartProps> = (props) => {
  return (
    <Pie
      data={props.data}
      options={props.options}
      height={props.height}
    />
  )
}
export default PieChart
